import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=7578a7c0&scoped=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"
import style0 from "./Image.vue?vue&type=style&index=0&id=7578a7c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7578a7c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7578a7c0')) {
      api.createRecord('7578a7c0', component.options)
    } else {
      api.reload('7578a7c0', component.options)
    }
    module.hot.accept("./Image.vue?vue&type=template&id=7578a7c0&scoped=true", function () {
      api.rerender('7578a7c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/Image.vue"
export default component.exports